import { Box } from 'theme-ui'

import Type from 'src/components/gel/Type'
import NewsletterModal from 'src/components/newsletter/NewsletterModal'

const NewsletterFooter = () => {
  return (
    <Box
      sx={{
        background: 'background.primary',
        color: 'text.quaternary',
        borderTop: '2px solid #EEEEEE',
        py: 6,
        px: 4,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: ['wrap', null, 'nowrap'],
        gap: [2, null, 4]
      }}
    >
      <Type variant="LabelsSerif" as="h2" sx={{ pr: 2, width: ['100%', null, 'auto'] }}>
        <Box as="b">The Ad</Box>vantage
      </Type>
      <Box sx={{ flex: 1, pb: [2, null, 0] }}>
        <Type variant="MetaData">
          Your quarterly look into BBC Studios&apos; Changemaker audience insights
        </Type>
      </Box>
      <Box sx={{ width: ['100%', null, 'auto'] }}>
        <NewsletterModal />
      </Box>
    </Box>
  )
}

export default NewsletterFooter
